const containsHTMLRegExp = new RegExp(
    /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i,
)

export function doesStringContainHTML(string: string): boolean {
    return containsHTMLRegExp.test(string)
}

/**
 * Replaces placeholders in a template string with values from an array.
 * The index in the array corresponds to the number of the placeholder in the template.
 * The template string must contain placeholders in the following format: #{index}.
 * @param {string} template - Template string containing placeholders.
 * @param {string} replacements - Accepts multiple parameters that are converted to an array.
 * @example
 * const template = "This item #{0} on #{1}";
 * const replacements = ...[
 *   footerData?.lastModifiedOn?.label,
 *   footerData?.lastModifiedOn?.date,
 *   ];
 * @returns {string} Template string with placeholders replaced.
 * @example "This item was last modified on 01/01/2021"
 */
export function formatString(
    template: string,
    ...replacements: string[] | number[]
): string {
    for (let i = 0; i < replacements.length; i++) {
        const exp = new RegExp("\\#{" + i + "\\}", "gm")
        template = template.replace(exp, replacements[i].toString())
    }
    for (let i = 0; i < replacements.length; i++) {
        const exp = new RegExp("\\{" + i + "\\}", "gm")
        template = template.replace(exp, replacements[i].toString())
    }
    return template
}

const stripHelper = document.createElement("div")
export function stripTags(str: string): string {
    stripHelper.innerHTML = str
    return stripHelper.textContent || ""
}

// + operator: to convert a string containing a number into a number
// because parseInt loosely converts. like: parseInt('12px321') => 12
// returns the numeric value of the string, or NaN
// if the string isn't purely numeric characters
export const isNumber = (text: string): boolean => !isNaN(+text)
